import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import Select from 'react-select';

import { required, number, positiveNumber } from '../../../forms';
import EditBrandHotelContact from './EditBrandHotelContact';

export const LabeledInput = ({ input, label, placeholder, type, meta }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
      placeholder={placeholder}
    />
    {meta.touched &&
      ((meta.error && <div><span className="alert-danger">{meta.error}</span></div>) ||
        (meta.warning && <div><span className="alert-danger">{meta.warning}</span></div>))}
  </InputGroup>
);

const RenderSelectInput = ({input, options, name, id, label, help, placeholder, meta: { active, touched, error, warning }}) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={(value) => {
        const values = value.map(v => v.value);
        input.onChange(values);
      }}
      onBlur={(value) => input.onBlur(value.value)}
      multi
      joinValues
      placeholder={placeholder}
    />
    {(help && <HelpBlock>{help}</HelpBlock>)}
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </FormGroup>
);

const BidSendForm = ({ onSubmit, initialValues, options, handleClose, ContactPopUpShow, ContactPopupHide,showPopUp, bid, loginUser, updateHotelContacts, deleteHotelContacts,updateContact, updateMergeValue }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={(values) => {
      const errors = {};
      if (!values.contacts) {
        if (!values.name) {
          errors.FORM_ERROR = 'Please select a existing user or invite a new one.';
        }
        if (!values.email) {
          errors.email = 'Email is required.';
        }
      }
      return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <div>
        <form onSubmit={handleSubmit} >
          <FormGroup>
            <Field
              label="To"
              name="contacts"
              component={RenderSelectInput}
              options={options}
              placeholder="Select previously added contact for this hotel"
            />
          </FormGroup>
          <FormGroup>
            <ButtonToolbar>
              <Button onClick={()=>ContactPopUpShow()}>Edit Contacts</Button>
            </ButtonToolbar>
          </FormGroup>
          <p>Or invite a new person to complete the booking request.</p>
          <FormGroup>
            <Field
              name="name"
              component={LabeledInput}
              label="Name"
              placeholder="John Smith"
            />
            <Field
              name="email"
              component={LabeledInput}
              label="Email"
              placeholder="john@example.com"
            />
          </FormGroup>
          { (!pristine && errors.FORM_ERROR) && (
            <p className="alert alert-danger">{errors.FORM_ERROR}</p>
          )}

          <FormGroup>
            <ButtonToolbar>
              <Button
                disabled={pristine || submitting}
                bsStyle="success"
                type="submit"
              >Send</Button>
              <Button
                disabled={submitting}
                bsStyle="success"
                onClick={handleClose}
              >Cancel</Button>
            </ButtonToolbar>
          </FormGroup>
        </form>
        {showPopUp &&(
          <EditBrandHotelContact
            showPopUp={showPopUp}
            ContactPopupHide={ContactPopupHide}
            bid={bid}
            updateHotelContacts={updateHotelContacts}
            deleteHotelContacts={deleteHotelContacts}
            updateContact={updateContact}
            updateMergeValue={updateMergeValue}
            loginUser={loginUser}
            onSubmit={onSubmit}
          />
        )}
      </div>
    )}
  />
  );

export default BidSendForm;



// WEBPACK FOOTER //
// src/routes/booking/components/BidSendForm.js